import { render, staticRenderFns } from "./botmobile.vue?vue&type=template&id=42313a8c&scoped=true&"
import script from "./botmobile.vue?vue&type=script&lang=js&"
export * from "./botmobile.vue?vue&type=script&lang=js&"
import style0 from "./botmobile.vue?vue&type=style&index=0&id=42313a8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42313a8c",
  null
  
)

export default component.exports